import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { Button } from "components/shared/buttons"

const AddResolutionButton = ({ className = "", onClick }) => (
  <Button
    className={clsx(className, "border border-light-300 text-focus")}
    onClick={onClick}
    text="+ Add Resolution"
  />
)

AddResolutionButton.propTypes = {
  className: types.string,
  onClick: types.func.isRequired,
}

export default AddResolutionButton
